module.exports = __webpack_public_path__ + "static/img/bg.6f3bfcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/bg.png
// module id = RxEI
// module chunks = 11